var reportables={life:{type:'life_change',display:'Life Changes / COVID-19 Status'}};export default reportables;